import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { API_BASE_URL } from "../../../Config/Config";

export const fetchBatchData = createAsyncThunk("api/batch", async () => {
  const response = await fetch(
    `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-batches`
  );
  const data = await response.json();
  return data;
});

const batchSlice = createSlice({
  name: "batch",
  initialState: {
    batchdata: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchBatchData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBatchData.fulfilled, (state, action) => {
        state.loading = false;
        state.batchdata = action.payload;
      })
      .addCase(fetchBatchData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default batchSlice.reducer;
